import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import SEO from '../../components/SEO';
import { customerAuthApi } from '../../services/customerAuthApi';
import './AuthPage.css';

function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSubmitting(true);
    try {
      await customerAuthApi.forgot({ email: email.trim() });
      setSent(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="auth-page">
      <SEO title="Forgot password" description="Forgotten your ASG Shading password? Enter the email address on your account and we will send you a link to choose a new one." canonical="/forgot-password" noindex />
      <div className="auth-card">
        <p className="auth-eyebrow">ASG Shading</p>
        <h1 className="auth-title">Forgot your password?</h1>
        <p className="auth-subtitle">Enter your email and we'll send you a link to set a new one.</p>
        {sent ? (
          <p className="auth-notice">If an account exists for that email, a reset link is on its way. Check your inbox - the link expires in 1 hour.</p>
        ) : (
          <form className="auth-form" onSubmit={handleSubmit}>
            <div className="auth-field">
              <label htmlFor="email">Email</label>
              <input id="email" type="email" autoComplete="email" required value={email} onChange={(e) => setEmail(e.target.value)} />
            </div>
            {error && <p className="auth-error" role="alert">{error}</p>}
            <button type="submit" className="auth-btn" disabled={submitting}>
              {submitting ? 'Sending…' : 'Send reset link'}
            </button>
          </form>
        )}
        <p className="auth-meta-center"><Link to="/sign-in">← Back to sign in</Link></p>
      </div>
    </div>
  );
}

export default ForgotPasswordPage;
